<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import SitePageFormFields from '@components/site-pages/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, ChevronLeft } from 'lucide-svelte'

  const form = useForm({
    title: '',
    slug: '',
    content: '',
    show_on_signup: false,
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => ({ site_page: data }))
    $form.post('/admin/site_pages', {
      onSuccess: () => router.visit('/admin/site_pages'),
    })
  }

  let navigationProps = {
    title: "New site page",
    links: [{ text: "Admin", href: "/admin" }, { text: "Site Pages", href: "/admin/site_pages" }],
  }
</script>

<Page.Layout title="New site page">

  <Page.Navigation {...navigationProps} />

  <Page.Titles title="New site page" subtitle="Create a new site page">
    {#snippet buttons()}
      <Button text="Back" path="/admin/site_pages" BeforeIcon={ChevronLeft} />
      <Button type="submit" form="site-page-form" text="Create page" variant="submit" Icon={Save} loading={$form.processing} />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="site-page-form" onsubmit={handleSubmit}>
    <SitePageFormFields {form} />
  </Form.Element>

</Page.Layout>
